import 'lazysizes'
import RootWrapper from './src/components/layout/RootWrapper';

export const wrapRootElement = RootWrapper;